import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const points = ['Panza plana a la mañana. Distendida a la noche. Todos los días.', 'Comés zanahoria hervida y te inflás más que con una pizza.', 'Tu médico dijo "es estrés" y te fue con un protector gástrico.', 'Niebla mental de las 14 hs que te roba la tarde entera.', 'Ya no salís a comer tranquila porque no sabés qué te va a caer mal.'];
  return <section className="py-24 bg-brand-black relative overflow-hidden" data-id="element-155">
      {/* Subtle background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-red-900/5 to-transparent pointer-events-none" data-id="element-156" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-157">
        <div className="max-w-4xl mx-auto" data-id="element-158">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-center mb-16 max-w-3xl mx-auto space-y-4" data-id="element-159">
            <h2 className="text-3xl md:text-5xl font-bold font-[Poppins,_sans-serif] text-white" data-id="element-160">
              Tu problema no es la comida.
            </h2>
            <p className="text-2xl md:text-3xl font-bold font-[Poppins,_sans-serif] text-brand-light" data-id="element-161">
              Es que tu intestino no tiene mapa.
            </p>
            <p className="text-base md:text-lg text-gray-200 font-medium" data-id="element-162">
              La hinchazón, la fatiga y la niebla mental son señales de un
              sistema estancado. No son síntomas separados: se llama SIBO.
            </p>
          </motion.div>

          <div className="grid gap-4 md:gap-6 mb-16" data-id="element-163">
            {points.map((point, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start gap-4 bg-[#2a0a0a] p-5 rounded-xl border border-red-900/80" data-id="element-164">
                <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-165" />
                <p className="text-lg text-gray-200" data-id="element-166">{point}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}